<p-tabs scrollable value="0">
  <p-tablist>
    <p-tab value="0">Profile Count</p-tab>
    <p-tab value="1">All Profiles</p-tab>
  </p-tablist>
  <p-tabpanels>
    <p-tabpanel value="0">
      <app-payment-profiles-count></app-payment-profiles-count>
    </p-tabpanel>
    <p-tabpanel value="1">
      <app-payment-all-profiles></app-payment-all-profiles>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>
